class Kereso {
    constructor() {

        this.baseparent = 'header.main-line';

        if (window.width < 992) {
            this.baseparent = '.mobile-header-right';
        }

        this.changeBaseParent();


        $(window).on('resize', () => {
            this.changeBaseParent();
        });

        $('body').on('click', (e) => {
            if ($(e.target).closest('.search-results-panel').length === 0) {
                $('.search-results-panel').addClass('d-none').empty();
                if ($(window).width() < 992 && $('.mobile-header-right .search-panel-kont').hasClass('d-none')) {
                    $('header.main-line').removeClass('d-none');
                }
            }
        });

    }

    changeBaseParent() {
        if ($(window).width() < 992) {
            this.baseparent = '.mobile-header-right';
        } else {
            this.baseparent = 'header.main-line';
        }

        if ($(this.baseparent + ' .search-panel').length > 0) {

            this.searchInput = $(this.baseparent + ' .search-panel input');
            this.searchButton = $(this.baseparent + ' .search-panel a.search');
            this.searchPageUrl = $(this.baseparent + ' .search-panel').data('search-url');

            this.initEvents();

            // $(this.baseparent + ' .search-results-panel').css('top', $(this.baseparent + ' .search-panel').offset().top + $(this.baseparent + ' .search-panel').outerHeight() + 15 + 'px');
            $(this.baseparent + ' .search-results-panel').css('left', $(this.baseparent + ' .search-panel').offset().left + 'px');

            if ($(window).width() < 992) {
                $(this.baseparent + ' .search-results-panel').css('width', $(this.baseparent + ' .search-panel-kont .container .col').outerWidth() + 'px');
            } else {
                $(this.baseparent + ' .search-results-panel').css('width', $(this.baseparent + ' .top-right-items').outerWidth() + 'px');

                $('header.main-line').removeClass('d-none');
            }
        }

    }

    initEvents() {

        if (!this.searchInput.data('initialized')) {
            this.searchInput.on('keyup', (e) => {

                if ($(window).width() < 992) {
                    $('header.main-line').addClass('d-none');
                }

                if (this.searchInput.val().length > 2) {
                    if (e.key === 'Enter') {
                        window.location.href = this.searchPageUrl + '?q=' + this.searchInput.val();
                    }

                    this.search(this.searchInput.val());
                } else {
                    $(this.baseparent + ' .search-results-panel').addClass('d-none').empty();
                }

            });
            this.searchInput.data('initialized', true);
        }

        if (!this.searchButton.data('initialized')) {
            this.searchButton.on('click', (e) => {
                e.preventDefault();
                window.location.href = this.searchPageUrl + '?q=' + this.searchInput.val();
            });
            this.searchButton.data('initialized', true);
        }

        if (!$('.mobile-header-right .search-button').data('initialized')) {

            $('.mobile-header-right .search-button').on('click', (e) => {
                e.preventDefault();
                $('.mobile-header-right .search-panel-kont').removeClass('d-none');
                $('header.main-line').addClass('d-none');
            });
            $('.mobile-header-right .search-button').data('initialized', true);
        }

        if (!$('.mobile-header-right .search-panel .close-me').data('initialized')) {
            $('.mobile-header-right .search-panel .close-me').on('click', (e) => {
                e.preventDefault();
                $('header.main-line').removeClass('d-none');
                $('.mobile-header-right .search-panel-kont').addClass('d-none');
                $('.mobile-header-right .search-panel-kont input').val('');
                $('.mobile-header-right .search-panel-kont .search-results-panel').empty().addClass('d-none');
            });
            $('.mobile-header-right .search-panel .close-me').data('initialized', true);
        }
    }


    search(query) {
        const searchResult = $(this.baseparent + ' .search-results-panel');



        console.log(
            this.baseparent,
            $(this.baseparent + ' .search-panel'),
            $(this.baseparent + ' .search-panel').offset(),
            $(this.baseparent + ' .search-panel').outerHeight()
        );

        // searchResult.css('top', $(this.baseparent + ' .search-panel').offset().top + $(this.baseparent + ' .search-panel').outerHeight() + 15 + 'px');
        searchResult.css('left', $(this.baseparent + ' .search-panel').offset().left + 'px');

        if ($(window).width() < 992) {
            searchResult.css('width', $(this.baseparent + ' .search-panel-kont .container .col').outerWidth() + 'px');
        } else {
            searchResult.css('width', $(this.baseparent + ' .top-right-items').outerWidth() + 'px');

            $('header.main-line').removeClass('d-none');
        }

        searchResult.removeClass('d-none');
        searchResult.addClass('waiting');
        if ($(window).width() < 992) {
            $('header.main-line').addClass('d-none');
        } else {
            $('header.main-line').removeClass('d-none');
        }

        $.get('/cimlapkereso/suggest', {
            q: query,
            r: new Date().getTime()
        }, (data) => {
            searchResult.removeClass('waiting');
            if (!data) {
                searchResult.addClass('d-none').empty();
                if ($(window).width() < 992) {
                    $('header.main-line').removeClass('d-none');
                }
                return;
            }
            if (data === 'empty') {
                searchResult.addClass('d-none').empty();
                if ($(window).width() < 992) {
                    $('header.main-line').removeClass('d-none');
                }
                return;
            }

            searchResult.html(data);
        }, 'html');

    }

}

export default Kereso;
